import { formatMonetary } from '@angeplus/prever-component-lib';

import { convertCentsToBRL } from './convertCentsToBRL';

export const formatCentsMonetary = (value: number): string => {
  if (value) {
    return formatMonetary(convertCentsToBRL(value));
  }
};
